<template>
<div>

    <div v-if="label" class="bold mb10">{{label}}</div>
    <div class="secondary-text mb10" v-if="description">{{description}}</div>

    <div @click.stop="ToggleFromField" ref="el">
        
            <slot></slot>
            <div v-show="!isHidden">
                <button v-if="icon" :class="`transparent icon icon-${icon}`"></button>
                <div v-else ref="input" :class="`input-field input-select relative after selectable ${inputClass}`">
                    
                    <button class="absolute fill trbl0 bgt"></button>
                    <div class="input" v-if="currentValue">{{currentValue.label}}</div>
                    <div class="input cgray2" v-else>{{placeholder}}</div>
                    <div class="after">
                        <i :class="`icon icon-arrow-down`"></i>
                    </div>
                </div>
            </div>

    </div>


    <modal v-model="isOpen" hideActions :domElement="popoverAnchorEl || $refs.el" :hideBackdrop="desktop" :dir="['up', 'center']" :modalClass="['w100 up']" ref="modal"
    :clickOutside="!submodalOpen">
        <div class="input-popover" style="padding: 0; max-height: 100%">
               
                <div v-if="isOpen" class="flex">

                    <div class="flex column pa10 options-panel unshrink">
                        <button v-for="option in selectOptions" :key="option.value" 
                        @click="currentOption = option.value"
                        :class="`ta-left ${currentOption == option.value ? 'selected' : ''}`">{{option.text}}</button>
                    </div>

                    <div class="flex column ofy pa10 flex-fill" style="max-height: 40vh">
                        <button v-for="(subOption, index) in subSelectOptions[currentOption]" :key="index" 
                        @click="SelectOption(subOption)"
                        :class="`ta-left ${currentValue.label == subOption.text ? 'selected' : ''}`"
                        style="white-space: pre">{{subOption.text}}</button>

                        <div v-if="currentOption == 'DAY'">
                            <div class="relative mb15 single-day-trigger-wrapper">
                                <button class="ta-left w100"
                                @click="OpenSingleDayCalendar"
                                style="white-space: pre">Otro día</button>
                                <input-date inputClass="sm"
                                ref="singleDayInput"
                                v-model="singleDay"
                                type="DATE"
                                instantSelect="DAY"
                                modalOnly
                                format="timestamp"
                                class="single-day-hidden-input"
                                @OnAcceptDate="SelectSingleDay"
                                @OnModalDateChanged="$event => submodalOpen = $event">
                                </input-date>
                            </div>
                        </div>

                        <div v-if="currentOption == 'MONTH'">
                            <div class="relative mb15 single-day-trigger-wrapper">
                                <button class="ta-left w100"
                                @click="OpenSingleMonthCalendar"
                                style="white-space: pre">Otro mes</button>
                                <input-date inputClass="sm"
                                ref="singleMonthInput"
                                v-model="singleMonth"
                                type="DATE"
                                instantSelect="MONTH"
                                modalOnly
                                format="timestamp"
                                class="single-day-hidden-input"
                                @OnAcceptDate="SelectSingleMonth"
                                @OnModalDateChanged="$event => submodalOpen = $event">
                                </input-date>
                            </div>
                        </div>

                        <div v-if="currentOption == 'RANGE'" class="pa10">
                            <input-date inputClass="sm"
                            ref="rangeStart"
                            v-model="start"
                            class="mb15"
                            label="Inicio"
                            format="timestamp"
                            @OnModalDateChanged="$event => submodalOpen = $event"
                            @OnModalTimeChanged="$event => submodalOpen = $event">
                            </input-date>

                            <input-date inputClass="sm"
                            ref="rangeFinish"
                            v-model="finish"
                            class="mb15"
                            label="Fin"
                            format="timestamp"
                            @OnModalDateChanged="$event => submodalOpen = $event"
                            @OnModalTimeChanged="$event => submodalOpen = $event">
                            </input-date>

                            <button class="primary purple w100" @click="SearchRange">Aceptar</button>
                        </div>

                    </div>
                    
                </div>
                
        </div>
    </modal>
    
</div>
</template>

<script>
var moment = require('moment');
moment.locale('es');
export default {
    props: {
        value: {
            type: [Object, String],
            default: () => {}
        },
        largeDates: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        inputClass: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        },
        isHidden: {
            type: Boolean,
            default: false
        },
        triggerFirstValueChanged: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            currentValue: null,
            range: null,
            currentOption: 'DAY',
            selectOptions: [],
            subSelectOptions: {
                DAY: [],
                WEEK: [],
                MONTH: [],
                YEAR: []
            },
            start: null,
            finish: null,
            singleDay: null,
            singleMonth: null,
            isOpen: false,
            submodalOpen: false,
            /** Ancla opcional para posicionar el popover en desktop (p. ej. barra sticky). */
            popoverAnchorEl: null,
        }
    },
    mounted() {
        this.Init();
    },
    methods: {
        Init() {

        this.selectOptions = [
            {text: 'Seleccionar Día', value: 'DAY'},
            {text: 'Seleccionar Semana', value: 'WEEK'},
            {text: 'Seleccionar Mes', value: 'MONTH'},
            {text: this.mobile ? 'Seleccionar Año' : 'Seleccionar Año o Periodo', value: 'YEAR'},
            {text: 'Seleccionar Rango', value: 'RANGE'},
        ];

        this.subSelectOptions = { DAY: [], WEEK: [], MONTH: [], YEAR: [] };

        var current = moment();

        this.start = moment().startOf('day').unix();
        this.finish = moment().endOf('day').unix();
        this.singleDay = moment().startOf('day').unix();
        this.singleMonth = moment().startOf('month').unix();

        current = moment();
        for(var i = 0; i <= 14; i++)
        {
            var label = current.format('ddd D MMMM');
            if(this.desktop)
            {
                if(i==0) label += ' (Hoy)';
                if(i==1) label += ' (Ayer)';
            }
            this.subSelectOptions.DAY.push({
                text: label,
                value: {
                    option: 'DAY',
                    label: label,
                    rangeStart: current.startOf('day').unix(),
                    rangeEnd: current.endOf('day').unix()
                }
            });
            current.subtract(1, 'day');
        }
        current = moment();
        this.subSelectOptions.DAY.push({
            text: 'Últimas 24 horas',
            value: {
                option: 'DAY',
                label: 'Últimas 24 horas',
                rangeStart: current.unix() - 3600,
                rangeEnd: current.unix()
            }
        });

        current = moment();
        this.subSelectOptions.WEEK.push({
            text: 'Esta semana',
            value: {
                option: 'DAY',
                label: 'Esta semana',
                rangeStart: current.startOf('week').unix(),
                rangeEnd: current.endOf('week').unix()
            }
        });
        current = current.subtract(1, 'week');
        this.subSelectOptions.WEEK.push({
            text: 'Semana pasada',
            value: {
                option: 'DAY',
                label: 'Semana pasada',
                rangeStart: current.startOf('week').unix(),
                rangeEnd: current.endOf('week').unix()
            }
        });
        current = current.subtract(1, 'week');
        this.subSelectOptions.WEEK.push({
            text: 'Semana ante pasada',
            value: {
                option: 'DAY',
                label: 'Semana ante pasada',
                rangeStart: current.startOf('week').unix(),
                rangeEnd: current.endOf('week').unix()
            }
        });
        current = moment();
        this.subSelectOptions.WEEK.push({
            text: 'Últimos 7 días',
            value: {
                option: 'DAY',
                label: 'Últimos 7 días',
                rangeStart: current.unix() - (7*24*3600),
                rangeEnd: current.unix()
            }
        });

        current = moment();
        for(var i = 0; i < 12; i++)
        {
            var label = current.format('MMMM YYYY');
            this.subSelectOptions.MONTH.push({
                text: label,
                value: {
                    option: 'MONTH',
                    label: label,
                    rangeStart: current.startOf('month').unix(),
                    rangeEnd: current.endOf('month').unix()
                }
            });
            current.subtract(1, 'month');
        }
        current = moment();
        this.subSelectOptions.MONTH.push({
            text: 'Últimos 30 días',
            value: {
                option: 'MONTH',
                label: 'Últimos 30 días',
                rangeStart: current.unix() - (30*24*3600),
                rangeEnd: current.unix()
            }
        });

        current = moment();
        do {
            this.subSelectOptions.YEAR.push({
                text: current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: current.format('YYYY'),
                    rangeStart: current.startOf('year').unix(),
                    rangeEnd: current.endOf('year').unix()
                }
            });
            
            this.subSelectOptions.YEAR.push({
                text: '- 2do semestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '2do semestre ' + current.format('YYYY'),
                    rangeStart: current.month(6).startOf('month').unix(),
                    rangeEnd: current.clone().month(11).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '- 1er semestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '1er semestre ' + current.format('YYYY'),
                    rangeStart: current.month(0).startOf('month').unix(),
                    rangeEnd: current.clone().month(5).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '- 3er trimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '3er trimestre ' + current.format('YYYY'),
                    rangeStart: current.month(8).startOf('month').unix(),
                    rangeEnd: current.clone().month(11).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '- 2do trimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '2do trimestre ' + current.format('YYYY'),
                    rangeStart: current.month(4).startOf('month').unix(),
                    rangeEnd: current.clone().month(7).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '- 1er trimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '1er trimestre ' + current.format('YYYY'),
                    rangeStart: current.month(0).startOf('month').unix(),
                    rangeEnd: current.clone().month(3).endOf('month').unix()
                }
            });
            /*
            this.subSelectOptions.YEAR.push({
                text: '  4to cuatrimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '4to cuatrimestre ' + current.format('YYYY'),
                    rangeStart: current.month(9).startOf('month').unix(),
                    rangeEnd: current.clone().month(11).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '  3er cuatrimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '3er cuatrimestre ' + current.format('YYYY'),
                    rangeStart: current.month(6).startOf('month').unix(),
                    rangeEnd: current.clone().month(8).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '  2do cuatrimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '2do cuatrimestre ' + current.format('YYYY'),
                    rangeStart: current.month(3).startOf('month').unix(),
                    rangeEnd: current.clone().month(5).endOf('month').unix()
                }
            });

            this.subSelectOptions.YEAR.push({
                text: '  1er cuatrimestre ' + current.format('YYYY'),
                value: {
                    option: 'YEAR',
                    label: '1er cuatrimestre ' + current.format('YYYY'),
                    rangeStart: current.month(0).startOf('month').unix(),
                    rangeEnd: current.clone().month(2).endOf('month').unix()
                }
            });
            */

            current.subtract(1, 'year');
        } while(current.year() >= 2019)

        
        //this.currentOption = this.value && this.value.option ? this.value.option : 'DAY';
        //this.range = this.value && this.value.index ? this.subSelectOptions[this.currentOption][this.value.index].value : null;
        //console.log(this.value);
        if(this.value)
        {
            if(this.value == 'NONE')
            {
                this.currentValue = {};
            }
            else
            {
                let optionsByType = this.subSelectOptions[this.value.option];
                let optionByIndex = optionsByType && this.value.index !== undefined ? optionsByType[this.value.index] : null;
                
                if(optionByIndex)
                {
                    this.currentValue = optionByIndex.value;
                    this.currentOption = this.value.option;
                }
                else if(this.value.rangeStart && this.value.rangeEnd)
                {
                    this.currentValue = this.value;
                    this.currentOption = this.value.option || 'RANGE';
                }
                else
                {
                    this.currentValue = this.subSelectOptions.DAY[0].value;
                }
            }
        }
        else
        {
            this.currentValue = this.subSelectOptions.DAY[0].value;
        }

        if (this.currentValue && this.currentValue.rangeStart != null) {
            let fromRange = moment.unix(this.currentValue.rangeStart);
            this.singleDay = fromRange.clone().startOf('day').unix();
            this.singleMonth = fromRange.clone().startOf('month').unix();
        }

        },
        OpenSingleDayCalendar() {
            if (this.currentValue && this.currentValue.rangeStart != null)
                this.singleDay = moment.unix(this.currentValue.rangeStart).startOf('day').unix();
            if (this.$refs.singleDayInput && typeof this.$refs.singleDayInput.OpenCalendar === 'function')
                this.$refs.singleDayInput.OpenCalendar();
        },
        SelectSingleDay(timestamp) {
            let day = (typeof timestamp === 'number') ? timestamp : this.singleDay;
            if (day == null) return;
            
            let todayDate = moment.unix(day).startOf('day');
            this.singleDay = todayDate.unix();
            let label = todayDate.format('ddd D MMMM YYYY');
            
            if (this.desktop) {
                if (todayDate.isSame(moment(), 'day')) label += ' (Hoy)';
                else if (todayDate.isSame(moment().clone().subtract(1, 'day'), 'day')) label += ' (Ayer)';
            }

            this.currentValue = {
                option: 'DAY',
                label: label,
                rangeStart: todayDate.clone().startOf('day').unix(),
                rangeEnd: todayDate.clone().endOf('day').unix()
            };
            this.isOpen = false;
        },
        OpenSingleMonthCalendar() {
            if (this.currentValue && this.currentValue.rangeStart != null)
                this.singleMonth = moment.unix(this.currentValue.rangeStart).startOf('month').unix();
            if (this.$refs.singleMonthInput && typeof this.$refs.singleMonthInput.OpenCalendar === 'function')
                this.$refs.singleMonthInput.OpenCalendar();
        },
        SelectSingleMonth(timestamp) {
            let monthTs = (typeof timestamp === 'number') ? timestamp : this.singleMonth;
            if (monthTs == null) return;

            let monthDate = moment.unix(monthTs).startOf('month');
            this.singleMonth = monthDate.unix();
            let label = monthDate.format('MMMM YYYY');

            this.currentValue = {
                option: 'MONTH',
                label: label,
                rangeStart: monthDate.clone().startOf('month').unix(),
                rangeEnd: monthDate.clone().endOf('month').unix()
            };
            this.isOpen = false;
        },
        SelectOption(option)
        {
            this.currentValue = option.value;
            this.isOpen = false;
        },
        SearchRange(labelTxt = null)
        {
            console.log(this.start);
            console.log(this.finish);
            if(this.start < this.finish)
            { 
                if (labelTxt instanceof Event) labelTxt = null;
                this.currentValue = {
                    option: 'RANGE',
                    //label: `${this.Util.Date(this.start, 'DD/MM/YYYY HH:mm')} - ${this.Util.Date(this.finish, 'DD/MM/YYYY HH:mm')}`,
                    label: labelTxt ? labelTxt : `${this.Util.Date(this.start, 'DD/MM/YYYY')} - ${this.Util.Date(this.finish, 'DD/MM/YYYY')}`,
                    rangeStart: this.start,
                    rangeEnd: this.finish + 59
                };
                this.isOpen = false;
            }
            else
            {
                this.Info('Rango inválido');
            }
        },
        Open(anchorEl) {
            this.popoverAnchorEl = (anchorEl && anchorEl.nodeType === 1) ? anchorEl : null;
            this.$nextTick(() => {
                this.isOpen = true;
            });
        },
        ToggleFromField() {
            this.popoverAnchorEl = null;
            this.isOpen = !this.isOpen;
        },
    },
    watch: {
        isOpen(n) {
            if (!n) this.popoverAnchorEl = null;
        },
        currentValue: function(n, o) {
            if (n && n.rangeStart != null) {
                let fromRange = moment.unix(n.rangeStart);
                this.singleDay = fromRange.clone().startOf('day').unix();
                this.singleMonth = fromRange.clone().startOf('month').unix();
            }
            this.$emit('input', n);
            if(o || this.triggerFirstValueChanged)
                this.$emit('OnValueChanged', n);
        },
        value: function(n) {
            if (n !== this.currentValue) this.Init();
        },
        largeDates: function() {
            this.Init();
        }
    }
}
</script>

<style lang="scss">
.input-popover .options-panel 
{
    background-color: var(--gray-3);
}
.dark .input-popover .options-panel 
{
    background-color: var(--dark-bg-1);
}
.single-day-trigger-wrapper {
    position: relative;
}
.single-day-hidden-input {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    pointer-events: none;
}
.single-day-hidden-input .input-group,
.single-day-hidden-input .input-field {
    width: 100%;
    height: 100%;
}
</style>
